import React, { useState } from "react";
import Hamburger from "./Hamburger";
import {
  AppBar,
  Typography,
  Toolbar,
  Tab,
  Tabs,
  Button,
  useTheme,
  useMediaQuery,
  Badge,
  Box,
  Grid,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import SettingsIcon from "@mui/icons-material/Settings";
import StorefrontIcon from "@mui/icons-material/Storefront";
import HistoryIcon from "@mui/icons-material/History";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import DinnerDiningIcon from "@mui/icons-material/DinnerDining";
import { useCart } from "react-use-cart";
import LogoutIcon from "@mui/icons-material/Logout";
import { useSnackbar } from "notistack";
import Avatar from "@mui/material/Avatar";
import Modal from "@mui/material/Modal";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button as MUIButton,
} from "@mui/material";
const style = {
  position: "absolute",
  top: "29%",
  left: "80%",
  transform: "translate(-50%, -50%)",

  bgcolor: "background.paper",

  boxShadow: 24,
};
const Header = ({ user, onLogout, updaterUser }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [value, setValue] = useState(0);
  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down("md"));
  const list = ["Home", "About us", "Contact us", "Collection"];
  const { totalUniqueItems } = useCart();
  const navigate = useNavigate();
  const [logoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);

  const handleOpenLogoutConfirmation = () => {
    setLogoutConfirmationOpen(true);
  };

  const handleCloseLogoutConfirmation = () => {
    setLogoutConfirmationOpen(false);
  };

  const handleConfirmLogout = () => {
    onLogout();
    setLogoutConfirmationOpen(false);
    enqueueSnackbar("You are logged out. Please log in to continue", {
      variant: "warning",
    });
    navigate("/login");
    setOpen(false);
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const myprofile = () => {
    navigate("/myprofile");
    setOpen(false);
  };
  return (
    <div>
      <AppBar sx={{ backgroundColor: "#1a193a" }}>
        <Toolbar>
          <Typography
            sx={{
              color: "black",
              display: "flex",
              ml: { lg: 10 },
              cursor: "pointer",
            }}
            onClick={() => navigate("/home")}
          >
            {" "}
            <StorefrontIcon
              sx={{ color: "white", mt: 0.7, height: 30, width: 30 }}
            />
           
            <Typography sx={{ fontSize: "1.8rem", color: "#f57192" }}>
            Bella
            </Typography>
            <Typography
              sx={{
                fontSize: "1.4rem",
                color: "white",
                fontWeight: "bold",
                mt: 1,
              }}
            >
               S
            </Typography>
            <Typography sx={{ fontSize: "1.4rem", color: "#f57192", mt: 1 }}>
              tore
            </Typography>
          </Typography>
          {isMatch ? (
            <Hamburger
              updaterUser={updaterUser}
              user={user}
              onLogout={onLogout}
            />
          ) : (
            <>
              <Tabs
                sx={{ marginLeft: "auto", color: "black", mr: { lg: 5 } }}
                textColor="primary"
                value={value}
                onChange={(e, newValue) => setValue(newValue)}
                indicatorColor="#fff"
              >
                {list.map((page, index) => (
                  <Link
                    to={page}
                    key={index}
                    style={{ textDecoration: "none" }}
                  >
                    <Tab
                      sx={{
                        fontSize: "1.3rem",
                        color: "white",
                        textTransform: "none",
                      }}
                      label={page}
                    />
                  </Link>
                ))}
              </Tabs>
              {user ? (
                <>
                  <Typography
                    sx={{
                      marginLeft: "auto",
                      display: "flex",
                      cursor: "pointer",
                    }}
                    onClick={handleOpen}
                  >
                    {" "}
                    <Avatar
                      alt={user.username}
                      src="/static/images/avatar/1.jpg"
                      sx={{
                        marginRight: 2,
                        bgcolor: "white",
                        mt: 0.9,
                        color: "#1a193a",
                      }}
                    />
                    <Typography
                      sx={{
                        color: "white",
                        marginLeft: "auto",
                        xs: { display: "block" },
                      }}
                    >
                      Hello,
                      <br />
                      <span
                        style={{
                          fontSize: "1.2rem",
                          color: "white",
                          fontWeight: "bold",
                        }}
                      >
                        {user.username}
                      </span>
                    </Typography>
                  </Typography>

                  <Button
                    onClick={handleOpenLogoutConfirmation}
                    sx={{
                      marginLeft: "left",
                      color: "white",
                      fontSize: "1.5rem",

                      "&:hover": {
                        color: "white",

                        opacity: [0.9, 0.8, 1.7],
                        transform: "scale(1.05)",
                        transition: "0.3s",
                      },
                    }}
                  >
                    <LogoutIcon />
                  </Button>
                </>
              ) : (
                <Button
                  onClick={() => navigate("/login")}
                  variant="contained"
                  sx={{
                    color: "white",
                    bgcolor: "#1a193a",
                    borderRadius: 15,
                    textTransform: "none",
                    marginRight: { lg: 3 },
                    ":hover": {
                      transform: "scale(1.1)",
                      transition: "0.3s",
                      bgcolor: "#fff",
                      color: "#022a6b",
                    },
                  }}
                >
                  Login
                </Button>
              )}
            </>
          )}

          <Link to="/Cart">
            <Badge
              color="error"
              badgeContent={totalUniqueItems}
              sx={{
                marginLeft: "auto",
                color: "white",
                fontSize: "1.8rem",
                paddingLeft: { lg: 3, md: 3 },
                paddingRight: { lg: 2 },
                cursor: "pointer",
                "&:hover": {
                  opacity: [0.9, 0.8, 1.7],
                  transform: "scale(1.1)",
                  transition: "0.3s",
                },
              }}
            >
              <AddShoppingCartIcon />
            </Badge>
          </Link>
        </Toolbar>
      </AppBar>
      <Dialog
        open={logoutConfirmationOpen}
        onClose={handleCloseLogoutConfirmation}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>Logout Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to logout?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseLogoutConfirmation} color="primary">
            No
          </Button>
          <Button onClick={handleConfirmLogout} color="primary">
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{ ...style, width: 550, height: 300 }}>
          <Grid container spacing={2}>
            <Grid item lg={6}>
              {" "}
              <Box
                component="img"
                height="300px"
                width="250px"
                src="https://wallpapers.com/images/hd/profile-picture-background-10tprnkqwqif4lyv.jpg"
                alt="Paella dish"
                sx={{}}
              />{" "}
            </Grid>
            <Grid item lg={6}>
              <Box sx={{ padding: 5 }}>
                <Typography
                  sx={{
                    fontSize: 17,
                    fontWeight: 700,
                    display: "flex",
                    mt: 2,
                    cursor: "pointer",
                  }}
                  onClick={myprofile}
                >
                  {" "}
                  My Profile
                </Typography>
                <Typography
                  sx={{
                    fontSize: 17,
                    fontWeight: 700,
                    display: "flex",
                    mt: 2,
                    cursor: "pointer",
                  }}
                >
                  {" "}
                  <HistoryIcon
                    sx={{ color: "#a33307", paddingRight: 1 }}
                    onClick={() => navigate("/myprofile")}
                  />{" "}
                  Order History
                </Typography>
                <Typography
                  sx={{
                    fontSize: 17,
                    fontWeight: 700,
                    display: "flex",
                    mt: 2,
                    cursor: "pointer",
                  }}
                >
                  {" "}
                  <SettingsIcon
                    sx={{ color: "#a33307", paddingRight: 1 }}
                  />{" "}
                  Settings{" "}
                </Typography>
                <Typography
                  sx={{
                    fontSize: 17,
                    fontWeight: 700,
                    display: "flex",
                    mt: 2,
                    cursor: "pointer",
                  }}
                  onClick={handleOpenLogoutConfirmation}
                >
                  {" "}
                  <LogoutIcon sx={{ color: "#a33307", paddingRight: 1 }} />{" "}
                  Logout
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
};

export default Header;
